// #1 Termo de Instauração de Investigação Interna — metadados de abertura +
// triagem + comitê designado. O "resumo dos fatos" (relato cifrado) fica manual.

import type { FormBlock } from './form-pdf.js';
import { manualField } from './form-pdf.js';
import {
  type FormInput,
  categoriaLabel,
  competenciaLabel,
  gravidadeLabel,
  rotaLabel,
  fmtDate,
  memberLabel,
  getTriagem,
  getOpenedAt,
  getAssignedMembers,
} from './forms-common.js';

export function buildInstauracao(input: FormInput): FormBlock[] {
  const triagem = getTriagem(input.state);
  const openedAt = getOpenedAt(input.state);
  const dataInstauracao = triagem?.classifiedAt ?? openedAt;
  const assigned = getAssignedMembers(input.state);

  const blocks: FormBlock[] = [
    { kind: 'title', text: 'Termo de Instauração de Investigação Interna' },
    { kind: 'section', text: 'Identificação' },
    { kind: 'field', label: 'Número da investigação:', value: input.caseId },
    { kind: 'field', label: 'Categoria:', value: categoriaLabel(input.categoria) },
    { kind: 'field', label: 'Comitê de competência:', value: competenciaLabel(input.categoria) },
    {
      kind: 'field',
      label: 'Data de instauração:',
      value: dataInstauracao === null ? '' : fmtDate(dataInstauracao),
    },
    { kind: 'field', label: 'Gravidade:', value: gravidadeLabel(triagem?.gravidade) },
    { kind: 'field', label: 'Rota do comitê:', value: rotaLabel(triagem?.rota) },
    { kind: 'section', text: 'Comitê designado' },
  ];

  if (assigned.length === 0) {
    blocks.push(manualField('Membros designados:'));
  } else {
    assigned.forEach((ulid, i) => {
      blocks.push({
        kind: 'field',
        label: `Membro ${String(i + 1)}:`,
        value: memberLabel(input.members, ulid),
      });
    });
  }

  blocks.push(
    { kind: 'section', text: 'Objeto da investigação' },
    manualField('Resumo dos fatos a apurar:'),
    { kind: 'spacer', mm: 6 },
    { kind: 'signature', nome: '', papel: 'Responsável pela instauração' },
  );

  return blocks;
}
